import { createWizardLogger } from './wizardLogger';

export const log = {
  bootstrap: createWizardLogger('wizard.bootstrap'),
  draft:     createWizardLogger('wizard.draft'),
  step:      createWizardLogger('wizard.step'),
  refs:      createWizardLogger('wizard.refs'),
  api:       createWizardLogger('wizard.api'),
  spell:     createWizardLogger('wizard.spell'),
  equipment: createWizardLogger('wizard.equipment'),
  error:     createWizardLogger('wizard.error'),
  i18n:      createWizardLogger('i18n'),
};

window.addEventListener('beforeunload', () => {
  Object.values(log).forEach(l => l.flush());
});
